import { Component, forwardRef, OnInit, Input, ViewChild, Output, EventEmitter,Inject } from '@angular/core';
import { Account, Plan } from 'src/app/models/AccountModel';
import { AccountAssessment } from 'src/app/models/AssessmentModel';
import { ResultFilter, PlatformApiService, PlanSearchCriteria } from 'src/app/services/platform-api.service';
import { DataTableComponent } from 'src/app/shared/tile-data-table/tile-data-table.component';
import { AssessmentService } from 'src/app/services/assessment.service';
import { SessionService } from 'src/app/services/session.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ConfirmationComponent } from 'src/app/shared/confirmation.component';
import { BuyNowPromptComponent } from 'src/app/shared/buynow-prompt.component';
import { Assessment } from 'src/app/models/AssessmentModel';
import { AssessmentTypeListComponent } from 'src/app/secured/assessment/assessment-type-list.component';

@Component({
  selector: 'cw-ci-account-certification-list',
  templateUrl: './account-certification-list.component.html',
  styleUrls: ['./account-certification-list.component.scss']
})
export class AccountCertificationListComponent implements OnInit {

  @Input() parentAccount: Account;
  @Input() account: Account;

  @Output() stateChange: EventEmitter<any> = new EventEmitter();
  @ViewChild(DataTableComponent, { static: true }) assessmentDataTable: DataTableComponent;
  assessmentList: AccountAssessment[];
  availablePlans: Plan[];

  constructor(private _platformApi: PlatformApiService, public sessionService: SessionService, public dialog: MatDialog) { }

  ngOnInit() {
  }

  isSelectable(assessment) {
    return true;
  }

  loadAssessments(filter: ResultFilter) {
    let assessmentListObservable;
    filter.searchData.assessmentTypes = ['CERTIFICATION'];
    if (this.parentAccount) {
      assessmentListObservable = this._platformApi.getAccountAssessments(this.parentAccount.id, this.account.id, filter);
    } else {
        assessmentListObservable = this._platformApi.getAccountAssessments(this.account.id, undefined, filter);
    }

    assessmentListObservable.subscribe(results => {
      this.assessmentList = results;
      console.log(results);
    })

  }

  selectAssessment(selectedAssessment: AccountAssessment) {
    if (selectedAssessment.status == 'COMPLETED') {
      this.stateChange.emit({ state: 'ASSESSMENT_REPORT', accountAssessment: selectedAssessment, account: this.account });
    } else {
      this.stateChange.emit({state:'EDIT_ASSESSMENT', accountAssessment: selectedAssessment, account: this.account});
    }
  }

  addAssessment(event?) {
    let newAccountAssessment = new AccountAssessment({accountId:this.account.id, assessmentId: 8})
    this._platformApi.saveAccountAssessment(this.parentAccount, newAccountAssessment).subscribe(accountAssessment => {
      this.assessmentDataTable.executeLoadItems();
    });
  }

  newAssessmentSurvey(selectedAssessment, selectedAssesValue) {
    const pAccountId = this.parentAccount ? this.parentAccount.id : selectedAssessment.accountId;
    const aId = this.parentAccount ? selectedAssessment.accountId : undefined;
    this._platformApi.getAccountAssessment(pAccountId, aId, selectedAssessment.id).subscribe(loadedAssessment => {
      const newAccountAssessment = new AccountAssessment({
        accountId: this.account.id,
        assessmentId: selectedAssesValue,
        prevId: selectedAssessment.id,
        surveyResultsJson: null
      });
      this._platformApi.saveAccountAssessment(this.parentAccount, newAccountAssessment).subscribe(accountAssessment => {
        loadedAssessment.nextId = accountAssessment.id;
        loadedAssessment.isLatest = false;
        this._platformApi.saveAccountAssessment(this.parentAccount, loadedAssessment).subscribe(prevAcctAssessment => {
          this.stateChange.emit({ state: 'EDIT_ASSESSMENT', accountAssessment, account: this.account });
        });
      });
    });
  }

  displayConfirmationComponent(selectedAssessment){
    const dialogRef = this.dialog.open(ConfirmationComponent, {
      panelClass: 'flush-dialog',
      data: {
        promptTitle: 'Copy Answers',
        promptMessage: [
          'Do you want to copy the existing answers for this assessment into the new assessment?'
        ],
        closeLabel: 'Cancel',
        buttons: [{label:'No', value:'NO', color:'primary'}, {label:'Yes', value:'YES', color:'primary'}],
        height: 'auto'
      }
    });
    dialogRef.afterClosed().subscribe(keepAnswers => {
      if (keepAnswers != undefined) {
        const pAccountId = this.parentAccount ? this.parentAccount.id : selectedAssessment.accountId;
        const aId = this.parentAccount ? selectedAssessment.accountId : undefined;
        this._platformApi.getAccountAssessment(pAccountId, aId, selectedAssessment.id).subscribe(loadedAssessment => {
          const newAccountAssessment = new AccountAssessment({
            accountId: loadedAssessment.accountId,
            assessmentId: loadedAssessment.assessmentId,
            prevId: loadedAssessment.id,
            surveyResultsJson: (keepAnswers == 'YES') ? loadedAssessment.surveyResultsJson : null
          });          
          this._platformApi.saveAccountAssessment(this.parentAccount, newAccountAssessment).subscribe(accountAssessment => {
            loadedAssessment.nextId = accountAssessment.id;
            loadedAssessment.isLatest = false;
            this._platformApi.saveAccountAssessment(this.parentAccount, loadedAssessment).subscribe(prevAcctAssessment => {
              this.stateChange.emit({ state: 'EDIT_ASSESSMENT', accountAssessment, account: this.account });
            });
          })
        });
      }
    });
  }

  getRiskColor(score) {
    const aServ = new AssessmentService();
    return aServ.getRiskColor({score});
  }

  getRiskLabel(score) {
    const aServ = new AssessmentService();
    return aServ.getRiskLabel({score});
  }
}
